import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoConsultaExterna({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [nombre, setNombre] = useState("");
  const [servicio, setServicio] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");
  const [loading, setLoading] = useState(false);

  const openModal = () => setIsOpen(true);

  const closeModal = () => {
    setIsOpen(false);
    setNombre("");
    setServicio("");
    setCargo("");
    setLider("");
    setLoading(false);
  };

  const postData = (e) => {
    e.preventDefault();
    setLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoOncologia",
      data: {
        nombre,
        servicio,
        cargo,
        lider,
        SolicitudId: idSolicitud,
      },
    })
      .then(() => {
        closeModal();
        if (onCreated) onCreated(); // 🔥 refresca la tabla
      })
      .catch((err) => {
        console.log(err);
        alert("Error al crear el equipo");
        setLoading(false);
      });
  };

  return (
    <>
      <button className="btn btn-primary" onClick={openModal}>
        Nueva
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Crear EQUIPO PRIMARIO DE MEJORAMIENTO DE ONCOLOGÍA
              </h6>
            </div>
            <div className="card-body">
              <form onSubmit={postData}>
                <input
                  className="form-control mb-2"
                  placeholder="Nombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                />
                <input
                  className="form-control mb-2"
                  placeholder="Servicio"
                  value={servicio}
                  onChange={(e) => setServicio(e.target.value)}
                  required
                />
                <input
                  className="form-control mb-2"
                  placeholder="Cargo"
                  value={cargo}
                  onChange={(e) => setCargo(e.target.value)}
                  required
                />
                <select
                  className="form-control mb-3"
                  value={lider}
                  onChange={(e) => setLider(e.target.value)}
                  required
                >
                  <option value="">¿Es líder?</option>
                  <option value="Si">SI</option>
                  <option value="No">NO</option>
                </select>

                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Guardando..." : "Guardar"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaEquipoConsultaExterna;
